import React from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from './authConfig';

const APP_LOCAL_LOGOUT_KEY = 'simap.localLoggedOut';

function LoginPage() {
  const { instance } = useMsal();

  const handleLogin = () => {
    localStorage.removeItem(APP_LOCAL_LOGOUT_KEY);
    instance.loginRedirect(loginRequest);
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>Cablex SIMAP Webapp</h1>
        <p style={styles.subtitle}>Sign in with your Cablex account to continue</p>
        <button style={styles.button} onClick={handleLogin}>
          Sign in
        </button>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    backgroundColor: '#f0f2f5',
  },
  card: {
    backgroundColor: 'white',
    padding: '48px',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    textAlign: 'center',
    maxWidth: '400px',
    width: '100%',
  },
  title: {
    margin: '0 0 8px 0',
    color: '#333',
    fontSize: '28px',
  },
  subtitle: {
    margin: '0 0 32px 0',
    color: '#666',
    fontSize: '14px',
  },
  button: {
    backgroundColor: '#d8002d',
    color: 'white',
    border: 'none',
    padding: '12px 32px',
    fontSize: '16px',
    borderRadius: '4px',
    cursor: 'pointer',
    width: '100%',
  },
};

export default LoginPage;
